import Cookies from 'js-cookie';

const getDeviceIdCookie = () => {
    const cookie = Cookies.get('device');
    if (cookie) {
        console.debug('Device id read from cookie:', cookie);
        return { device_id: cookie };
    } else {
        const newDeviceId = Math.random().toString();
        Cookies.set('device', newDeviceId, { expires: 365 });
        console.debug("No device id cookie found, generating new device id:", newDeviceId);
        return { device_id: newDeviceId };
    }
};

export default getDeviceIdCookie;
